import "../CSS/mesureSettings.css";
import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import db from "../FireBase/firebase"; 

function GrapheSettings({onChange}) {

  // Récupérer la valeur initiale de nbPoints depuis localStorage
  const [nbPoints, setNbPoints] = useState(localStorage.getItem('nbPoints') || 30);
  const [paramGraph, setParamGraph] = useState([]);

  useEffect(() => {
    const paramRef = ref(db, "parametres/graphes");
    const unsubscribe = onValue(
      paramRef,
      (snapshot) => {
        const fetchedMesures = [];
        snapshot.forEach((childSnapshot) => {
          const key = childSnapshot.key;
          const data = childSnapshot.val();
          fetchedMesures.push({ id: key, ...data });
        });
        setParamGraph(fetchedMesures);
      },
      (error) => {
        console.error("Erreur lors du chargement des paramètres de mesure :", error);
      }
    );
  
    return () => unsubscribe();
  }, []);

  // Fonction pour mettre à jour nbPoints
  const setNumPoints = (num) => {
    setNbPoints(num);  // Mettre à jour l'état local
    localStorage.setItem('nbPoints', num);  // Mettre à jour localStorage
  };

  return (
    <div id="paramsGraphiques">
      <label>
        Nombre de points à afficher par graphique :
        <input
          id="nbPointsInput"
          type="number"
          value={nbPoints}
          onChange={(e) => setNumPoints(Number(e.target.value))}
          min="1"
          max="100"
        />
      </label>

      <h4>Selectionner les graphiques à afficher</h4>
      <div id="selectGraphes">
      {paramGraph.map(({ id, field, visible }) => (
        <label key={id}>
          <input
            type="checkbox"
            checked={visible}
            onChange={() => onChange("Graphe"+id)}
          />
          {id}
        </label>
      ))}
      </div>
    </div>
  );
}

export default GrapheSettings;
